
import React, { useCallback, useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import {
  getTime,
  getDate,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";
import { useWindowSize } from "services/resizeservice";

function BatteriesErrorComponent(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    BarChart,
    CanvasRenderer,
  ]);
  const [axisData, setAxisData] = useState([]);
  var xAxisData = [];
  var yAxisSoc10 = 0;
  var yAxisSoc20 = 0;
  var yAxisSoc30 = 0;
  var yAxisSoc40 = 0;
  var yAxisSoc50 = 0;
  var yAxisSoc60 = 0;
  var yAxisSoc70 = 0;
  var yAxisSoc80 = 0;
  var yAxisSoc90 = 0;
  var yAxisSoc100 = 0;

  const setAxisDatas = useCallback(async () => {
    if(props.loading==="true"){
      xAxisData = [];
      yAxisSoc10 = 0;
      yAxisSoc20 = 0;
      yAxisSoc30 = 0;
      yAxisSoc40 = 0;
      yAxisSoc50 = 0;
      yAxisSoc60 = 0;
      yAxisSoc70 = 0;
      yAxisSoc80 = 0;
      yAxisSoc90 = 0;
      yAxisSoc100 = 0;
    }
    else if (props.data != undefined) {
      props.data.map(function (obj) {
        if (
          props.selectValue === "HOUR_24" ||
          props.selectValue === "HOUR_12"
        ) {
          xAxisData.push(getTime(obj.startDate));
        } else if (props.selectValue === "WEEK") {
          xAxisData.push(getDay(obj.startDate));
        } else {
          xAxisData.push(getDate(obj.startDate));
        }

        if (props.selectValue > "168") {
          xAxisData.push(getDate(obj.startDate));
        } else {
          xAxisData.push(getTime(obj.startDate));
        }

        if (obj.soc10 === null) {
          obj.soc10 = 0;
          yAxisSoc10 = parseInt(yAxisSoc10) + parseInt(obj.soc10);
          // yAxisSoc5.push(obj.soc10);
        } else {
          // yAxisSoc5.push(obj.soc10);
          yAxisSoc10 = parseInt(yAxisSoc10) + parseInt(obj.soc10);
        }

        if (obj.soc20 === null) {
          obj.soc20 = 0;
          yAxisSoc20 = yAxisSoc20 + parseInt(obj.soc20);
          // yAxisSoc20.push(obj.soc20);
        } else {
          // yAxisSoc20.push(obj.soc20);
          yAxisSoc20 = yAxisSoc20 + parseInt(obj.soc20);
        }

        if (obj.soc30 === null) {
          obj.soc30 = 0;
          yAxisSoc30 = yAxisSoc30 + parseInt(obj.soc30);
        } else {
          yAxisSoc30 = yAxisSoc30 + parseInt(obj.soc30);
        }

        if (obj.soc40 === null) {
          obj.soc40 = 0;
          yAxisSoc40 = yAxisSoc40 + parseInt(obj.soc40);
        } else {
          yAxisSoc40 = yAxisSoc40 + parseInt(obj.soc40);
        }

        if (obj.soc50 === null) {
          obj.soc50 = 0;
          yAxisSoc50 = yAxisSoc50 + parseInt(obj.soc50);
        } else {
          yAxisSoc50 = yAxisSoc50 + parseInt(obj.soc50);
        }

        if (obj.soc60 === null) {
          obj.soc60 = 0;
          yAxisSoc60 = yAxisSoc60 + parseInt(obj.soc60);
        } else {
          yAxisSoc60 = yAxisSoc60 + parseInt(obj.soc60);
        }

        if (obj.soc70 === null) {
          obj.soc70 = 0;
          yAxisSoc70 = yAxisSoc70 + parseInt(obj.soc70);
        } else {
          yAxisSoc70 = yAxisSoc70 + parseInt(obj.soc70);
        }

        if (obj.soc80 === null) {
          obj.soc80 = 0;
          // yAxisSoc80.push(obj.soc80);
          yAxisSoc80 = yAxisSoc80 + parseInt(obj.soc80);
        } else {
          // yAxisSoc80.push(obj.soc80);
          yAxisSoc80 = yAxisSoc80 + parseInt(obj.soc80);
        }
        if (obj.soc90 === null) {
          obj.soc90 = 0;
          // yAxisSoc80.push(obj.soc80);
          yAxisSoc90 = yAxisSoc90 + parseInt(obj.soc90);
        } else {
          // yAxisSoc80.push(obj.soc80);
          yAxisSoc90 = yAxisSoc90 + parseInt(obj.soc90);
        }

        if (obj.soc100 === null) {
          obj.soc100 = 0;
          // yAxisSoc95.push(obj.soc95);
          yAxisSoc100 = yAxisSoc100 + parseInt(obj.soc100);
        } else {
          // yAxisSoc95.push(obj.soc95);
          yAxisSoc100 = yAxisSoc100 + parseInt(obj.soc100);
        }
      });
    }
      setAxisData({
        xAxisData: xAxisData,
        yAxisSoc10: yAxisSoc10,
        yAxisSoc20: yAxisSoc20,
        yAxisSoc30: yAxisSoc30,
        yAxisSoc40: yAxisSoc40,
        yAxisSoc50: yAxisSoc50,
        yAxisSoc60: yAxisSoc60,
        yAxisSoc70: yAxisSoc70,
        yAxisSoc80: yAxisSoc80,
        yAxisSoc90: yAxisSoc90,
        yAxisSoc100: yAxisSoc100,
      });
    
  }, [props.loading]);

  useEffect(() => {
    setAxisDatas();
  }, [props.loading]);

  // if (props.selectValue == "168") {
  //   xAxisData = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  // }

  const options = () => ({
    tooltip: {
      trigger: "item",
    },
    grid: {
      left: "15%",
      right: "4%",
      bottom: "20%",
      containLabel: true,
      height: "60%",
    },
    xAxis: {
      type: "category",
      data: ["10%", "<20%","<30%", "<40%","<50%","<60%","<70%", ">80%", ">90%", "100%"],
      name: "SOC Level",
      nameLocation: "middle",
      nameGap: 40,
      axisTick: {
        show: false,
      },
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
      axisLabel: {
        rotate:
          props.selectValue === "WEEK_2" ||
          props.selectValue === "MONTH" ||
          props.selectValue === "MONTH_3"
            ? 30
            : 0,
      },
    },
    yAxis: {
      type: "value",
      // min: 0,
      // max:100,
      name: "No of Batteries",
      nameLocation: "middle",
      nameGap: 40,
      axisLabel: {
        formatter: formatYaxisNumber,
      },
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
    },
    series: [
      {
        type: "bar",
        /*emphasis: {
              itemStyle: {
                borderColor: 'transparent',
                color: 'transparent'
              }
            },*/
        data: [
          {
            value: axisData.yAxisSoc10,
            itemStyle: {
              color: "#E3324C",
            },
          },
          {
            value: axisData.yAxisSoc20,
            itemStyle: {
              color: "#FD824D",
            },
          },
          {
            value: axisData.yAxisSoc30,
            itemStyle: {
              color: "#FCC644",
            },
            
          },
          {
            value: axisData.yAxisSoc40,
            itemStyle: {
              color: "#FFC600",
            },
            
          },
          {
            value: axisData.yAxisSoc50,
            itemStyle: {
              color: "#CBDE20",
            },
            
          },
          {
            value: axisData.yAxisSoc60,
            itemStyle: {
              color: "#9AAB04",
            },
            
          },
          {
            value: axisData.yAxisSoc70,
            itemStyle: {
              color: "#52B130",
            },
            
          },
          {
            value: axisData.yAxisSoc80,
            itemStyle: {
              color: "#00792C",
            },
          },
          {
            value: axisData.yAxisSoc90,

            itemStyle: {
              color: "#5dd11e",
            },
          },
          {
            value: axisData.yAxisSoc100,
            itemStyle: {
              color: "#198754",
            },
          },
        ],
      },
    ],
  });

 
  return (
    <ReactEcharts
      styles={{ with: "100%", height: "90%" }}
      echarts={echarts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
      opts={{ renderer: "svg" }}
      option={options()}
    />
  );
}

export default BatteriesErrorComponent;
